module.exports = __webpack_public_path__ + "img/mindful_days_365.6d42b256.svg";